module.exports = __webpack_public_path__ + "img/xcjlogo.32cf4319.jpeg";